import { DateRange } from "components/form_components/Inputs";
import { LeadFilterContentProps, StyledFilterContent } from "./utils";

function LastUpdatedDateFilterContent({ control }: LeadFilterContentProps) {
  return (
    <StyledFilterContent aria-label="Last updated date filter">
      <DateRange name="lastUpdatedDate.filter" control={control} label="" showFutureDates={false} />
    </StyledFilterContent>
  );
}

export default LastUpdatedDateFilterContent;
